/*
 * File: 基础设置-组织架构-组织架构-编辑用户
 */
<template>
    <el-dialog
        :visible="visible"
        width="600px"
        title="编辑用户信息"
        custom-class="organization-user-dialog"
        destroy-on-close
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
    >
        <PublicForm
            ref="publicFormRef"
            label-width="80px"
            :row="formData"
            :config="config.user.formList"
            :col="config.user.col"
        />
        <span slot="footer">
            <el-button size="small" @click="handleClose">取消</el-button>
            <el-button type="primary" size="small" @click="handleSave" :loading="isLoading">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { ref, reactive } from '@vue/composition-api';
import { Message } from 'element-ui';
import PublicForm from '@/modules/mdm/components/form/Index.vue';
import { config as configStatic } from '../config';
import { updateUser } from '@mdm/api/basicSettings/organization.js';

export default {
    components: { PublicForm },
    props: {},
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const config = reactive(configStatic);
        const visible = ref(false);
        const formData = ref({});
        const isLoading = ref(false);

        const show = (data) => {
            visible.value = true;
            formData.value = { ...data };
        };
        const handleClose = () => {
            visible.value = false;
            formData.value = {};
        };
        // 保存
        const handleSave = () => {
            setupContext.refs.publicFormRef.validateForm().then(() => {
                const newData = setupContext.refs.publicFormRef.form;
                isLoading.value = true;
                updateUser({ ...newData, orgCode: formData.value.orgCode }).then((res) => {
                    isLoading.value = false;
                    if (res && +res.code === 0) {
                        Message.success('保存成功');
                        emit('confirm');
                        handleClose();
                    }
                });
            });
        };
        return {
            config,
            visible,
            formData,
            isLoading,
            show,
            handleClose,
            handleSave
        };
    }
};
</script>

<style lang="less">
.organization-user-dialog {
    .el-dialog__body {
        padding: 20px 20px 0px 10px;
    }
}
</style>
